export type AgentIssueStatus = 'open' | 'resolved' | 'ignored';

export type AgentIssueCategory =
  | 'risk'
  | 'legal_improvement'
  | 'consistency'
  | 'simplification'
  | 'clarity';

export type AgentIssueSeverity = 'low' | 'medium' | 'high';

export interface AgentIssue {
  id: string;
  paragraphIndex: number;
  originalText: string;
  suggestedText: string;
  explanation: string;
  category: AgentIssueCategory;
  severity: AgentIssueSeverity;
  groupId?: string;
  status: AgentIssueStatus;
}

export type AgentScanStatus = 'idle' | 'scanning' | 'done' | 'error';

export interface AgentScanResult {
  issues: AgentIssue[];
}

export const CATEGORY_LABELS: Record<AgentIssueCategory, string> = {
  risk: 'Risk',
  legal_improvement: 'Legal',
  consistency: 'Consistency',
  simplification: 'Simplification',
  clarity: 'Clarity',
};

export const SEVERITY_ORDER: Record<AgentIssueSeverity, number> = {
  high: 0,
  medium: 1,
  low: 2,
};
